import { ClientMatterContactDetails } from './../../core/models/client-matter-contact-details';
import { Component } from '@angular/core';
import { ClientService } from '../../core/services/client.service';
import { AuthService } from '../../core/services/auth.service';
import { combineLatest, forkJoin, take } from 'rxjs';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {

  ClientMatterContactDetails : ClientMatterContactDetails | undefined;
  mfaReminderSupressed = false;
  mfaEnabled: boolean | undefined = false;
  loading = true;

  constructor(private clientService: ClientService, private authService: AuthService) {
    clientService.getClientMatterContactDetails().subscribe(
          val => this.ClientMatterContactDetails = val
        );

    const mfaObservable = authService.GetMfaConfig();
    mfaObservable.subscribe((mfaDetails) => { this.mfaEnabled = mfaDetails.mfaEnabled });

    const mfaReminderObservable = clientService.getMfaReminderSupressed();
    mfaReminderObservable.subscribe(val => this.mfaReminderSupressed = val);

    combineLatest([mfaObservable, mfaReminderObservable])
      .pipe(take(1))
      .subscribe(() =>
        this.loading = false);
  }
}
